import { j as jsxRuntimeExports } from "./dayjs.min.js";
function Loading() {
  return jsxRuntimeExports.jsx("div", { className: "loader" });
}
const formatFileSize = (file) => {
  if (!file)
    return;
  const size = typeof file === "number" ? file : file.size;
  if (size < 1024) {
    return `${size} Bytes`;
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(1)} KB`;
  } else if (size < 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  } else {
    return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  }
};
const getFileType = (file) => {
  const fileType = file.substring(file.lastIndexOf(".") + 1).toLowerCase();
  const supportedFileTypes = ["doc", "docx", "xlsx", "ppt", "pptx", "pdf"];
  const iconFile = supportedFileTypes.includes(fileType) ? fileType : "file";
  return iconFile;
};
export {
  Loading as L,
  formatFileSize as f,
  getFileType as g
};
